import "./Header.css";

function Header() {
  return (
    <div className="header">
      <h2>WaitWise</h2>
      <button className="login-btn">Login</button>
    </div>
  );
}

export default Header;